import { Controller, FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DevTool } from "@hookform/devtools";
import { useState } from "react";
import schema from "./Validation";
import { Grid } from "@mui/material";
import { AcademicLevel, Campaigns,  ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components";
import { Dropdown, Email, InputText, PhoneNumber } from "components/fields";
import { useForms, useSalesforce, useSubmission, useUrlReturn } from "hooks";
import {
  campaigns,
  consent, consentement, defaultValues,specialities
} from "services";
import DropdownCommon from "components/fields/DropdownCommon";
import formations from "../services/formations";



const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar, setSnackMessage, setSnackSeverity } = useForms();
  const { submission } = useSubmission()
  const { url } = useUrlReturn('ISTM-JPO');
  const { url: url_contact } = useUrlReturn('ISTM-CONTACT');


  // Form
  const methods = useForm({
    defaultValues: {
      ...campaigns,
      ...consent,
      lead: {
        ...defaultValues,
        ...specialities.lead,
        ...consentement,
        Campus__c: 'Paris',
        Section__c: '',
        Wished_Programm__c: '',
      }
    },
    resolver: yupResolver(schema)
  });
  const { control, watch } = methods;
  const [optionsAcademicLevels, setOptionsAcademicLevels] = useState([]);
    //console.log('Selected campaign:', campaignId, 'Is online:', isOnline, 'Last form:', lastForm);


  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false);
    const lead = data.lead;
    const campaignId = data.campaignId;
    const campus = data.lead.Campus__c || 'Paris';


    const defaultDataLead = {
      Division__c: 'IONIS STM',
      IONISSchool__c: 'IONIS STM',
      LastForm__c: campaignId !== 'unavailable' ? 'JPO' : 'Contact téléphone',
      LeadSource: 'JPO',
      RecordTypeId: recordTypeId
    };


    const finalLead = { ...lead, ...defaultDataLead };

    try {
      if (campaignId !== 'unavailable') {
        await submission({
          formId: "JPO",
          lead: finalLead,
          campaignId: campaignId,
          campaignStatus: data.status,
          utmCookieName: "_ionis_user_data"
        })
        document.location.href = url;
      } else {
        await submission({
          formId: "CONTACT",
          lead: finalLead,
          subject: 'Ce prospect souhaite être recontacté',
          utmCookieName: "_ionis_user_data"
        })
        document.location.href = url_contact;
      }
    } catch (error) {
      console.error(' Error during form submission:', error);
      setError('Une erreur est survenue lors de la soumission du formulaire', error);
    }
  };

  // Watch
  const watchCampaignId = watch('campaignId')

  useSalesforce('Ionis-STM', false);

  const handleAcademicLevels = (academics) => {
    setOptionsAcademicLevels(academics);
  };

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber
            control={control}
            name="lead.MobilePhone"
            label="Téléphone"
            required
          />
        </Grid>
        <Grid item xs={12}>
          <Dropdown control={control} label="Je suis intéressé.e par le MSc" name="lead.Wished_Programm__c" native options={formations} required />
        </Grid>
        <AcademicLevel native school="IONIS STM" section={false} />
        <Campaigns setAcademicLevels={handleAcademicLevels} contact={false} division="IONIS STM" last_form="JPO" native school="IONIS STM" text="à la Journée Portes Ouvertes" textAvailability="pour nos journées portes ouvertes" type="JPO" />
        <ConsentementMultiple callOptIn={watchCampaignId === 'unavailable'} />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="JPO" school="IONIS STM" />
      </Grid>
    </FormProvider>
  )
};

export default Form;
